import React from 'react';
import { ThankYouCardAtom } from '../../atoms/thank-you-card/thank-you-card.atom';
import { ThankYouContainer } from '../../atoms/thank-you-container/thank-you-container.atom';
import { SuccessIcon } from '../../atoms/success-icon/success-icon.atom';
import { ThankYouTitle } from '../../atoms/thank-you-title/thank-you-title.atom';
import { Text } from '../../atoms/text/text.atom';
import { Divider } from '../../atoms/divider/divider.atom';
import { OrderDetail } from '../order-detail/order-detail.molecule';
import { useTranslation } from 'react-i18next';
import { useMetodoPagamentoVendaDescricao } from '../../../common/hooks/usePaymentMethodDescription';
import { Sell } from '../../../common/types/venda';
import { formatCurrency } from '../../../common/utils/format-currency';

type Props = {
  venda: Sell;
};

export const ThankYouCard: React.FC<Props> = ({ venda }) => {
  const { t } = useTranslation();
  const pm = useMetodoPagamentoVendaDescricao();
  return (
    <ThankYouCardAtom padding="2.5rem">
      <ThankYouContainer textAlign="center">
        <SuccessIcon />
        <ThankYouTitle size="2rem" weight="700" color="#1f2937">
          {t('thankYou')}!
        </ThankYouTitle>
        <Text size="1.125rem" color="#4b5563" align="center">
          {t('purchaseConfirmed')}
          <br />
          {t('thanksForBuying')} <br />
          {t('detailsComingSoon')}
          <br />
          {t('inYourEmail')}
        </Text>
      </ThankYouContainer>

      <Divider />

      <ThankYouContainer margin="1.5rem 0">
        <ThankYouTitle size="1.25rem" weight="600">
          {t('orderDetails')}
        </ThankYouTitle>
        <OrderDetail label={t('orderId')} value={venda?.id} />
        <OrderDetail label={t('product')} value={venda?.produto?.nome} />
        <OrderDetail
          label={t('total')}
          value={formatCurrency(venda?.valorOriginal ?? venda?.valorPago, venda?.moedaOriginal ?? venda?.moeda)}
        />
        <OrderDetail
          label={t('paymentMethod')}
          value={
            venda?.metodoPagamento != null
              ? pm[venda.metodoPagamento] ?? '—'
              : '—'
          }
        />
        <OrderDetail label={t('status')} value={t('confirmed')} />
      </ThankYouContainer>

      <Divider />

      <ThankYouContainer textAlign="center">
        <Text size="0.875rem" color="#6b7280">
          {t('confirmationLine1')}
          <br />
          {t('confirmationLine2')}
        </Text>
      </ThankYouContainer>
    </ThankYouCardAtom>
  );
};
